"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = require("./api");

Object.defineProperty(exports, "api", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_api).default;
  }
});

var _utils = require("./utils");

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-utils-js/lib/index.js
 ** module id = 396
 ** module chunks = 0
 **/